<template lang="pug">
.res-reschedule-process
  transition-group(name="fade")
    .status.success( key="1")
      notification(:status="$t('reservation.status')[7].code" :msg="$t('reservation.status')[7].msg" :subMsg="$t('reservation.status')[7].subMsg")

    countdown-btn(key="2" :countdown="3" :copy="$t('btn.complete')")
  
</template>
<script>
import AlipayService from '@/services/AlipayService'
import { mapMutations, mapState, mapActions } from 'vuex'
import Notification from '@/components/wedgits/Notification'
import CountdownBtn from '@/components/wedgits/CountdownBtn'
export default {
  name: 'ResRescheduleProcess',
  components: {
    CountdownBtn,
    Notification,
  },
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['user']),
  },
  created() {},
  methods: {
    ...mapMutations('app', ['setPending']),
    ...mapActions('app', ['ResCancel']),
    onMessage(data) {
      console.log('msg rec inside:', data)
    },
    onConfirm(e) {
      this.status = 1
    },
    onError() {
      console.log('error!!!!')
      this.status = 400
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.res-reschedule-process
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  //padding: 0 pxToRem(30)
  color: black
  overflow: hidden
  .status
    position: absolute
    top: pxToRem(64)
    left: 0
    text-align: center
    width: 100%
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
  .pending

  .success
    .name-card
      position: relative
      width: pxToRem(702)
      height: pxToRem(489)
      margin: pxToRem(100) auto

.fade-enter-active, .fade-leave-active
  transition: all 0.5s
.fade-enter
  transform: translateX(50%)
  opacity: 0
.fade-leave-to
  transform: translateX(-50%)
  opacity: 0
</style>
